/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React,{useEffect} from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import "./assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/scss/argon-dashboard-react.scss";

//import JobLayout from "layouts/Job.js";
//import UserLayout from "layouts/User.js";

import HomePage from './HomePage'
import Register from "views/examples/Register.js";
import Bars from './homePages/Bars'
import Venue from './homePages/Venue'
import AuthLayout from "./layouts/Auth.js";

import JobRoute from "./components/PrivateRoute/JobRoute";
import NextFaseVideoUpload from "views/examples/NextFaseVideoUpload";

import AdminLayout from "./layouts/Admin.js";
import ManagerRoute from "./components/PrivateRoute/ManagerRoute";
import AccManagerRoute from "./components/PrivateRoute/AccManagerRoute";
import UserRoute from "./components/PrivateRoute/UserRoute";
import SellerRoute from "./components/PrivateRoute/SellerRoute";
import SellerManagerRoute from "./components/PrivateRoute/SellerManagerRoute";
import ShopRoute from "./components/PrivateRoute/ShopRoute";
import SecurityRoute from "./components/PrivateRoute/SecurityRoute";

import ReSellerRoute from "./components/PrivateRoute/ReSellerRoute";

import QRCodeRoute from "./views/examples/clockinout/clockInOutQRCode";
import PrintQRCode from 'views/examples/merchShop/PrintQRCode';

//import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
//import EditOrders from "views/examples/ticketing/EditOrders";

import ConfirmEmail from "views/examples/ConfirmEmail";

import MainCameras from "views/examples/cameras/MainCameras";
import LastOrder from "views/examples/ticketing/LastOrder";
import MainePOS from "views/examples/ePOS/MainePOS";
import NiceReport from "views/examples/ticketing/NiceReport";

import PDFTest from 'views/0Test/PDFTest';
import MainAccess from "views/examples/accessControl/MainAccess";
import NewEventSales from "views/examples/ticketing/newTicketSales/NewEventSales";
import NewEvent from "views/examples/ticketing/newGeticketsWebsite/Events";
import ClientViewOrder from "views/examples/ClientViewOrder";



ReactDOM.render(
  
  <BrowserRouter>
  

  
    <Switch>
      <Route exact path="/" component={HomePage} />
      {/*<AuthRoutes path="/auth" component={AuthLayout} />*/}

      <Route exact path="/register" component={Register} />
      <Route path="/auth/confirm-email" component={ConfirmEmail} />

      <Route exact path="/bars" component={Bars} />
      <Route exact path="/venue" component={Venue} />

      <Route path="/auth" component={AuthLayout} />

      <Route exact path="/job" component={JobRoute}/>
      <Route exact path="/nextfase" component={NextFaseVideoUpload}/>

      <AdminLayout path="/admin" />
      <ManagerRoute path="/manager"/>
      <AccManagerRoute path="/accmanager"/>
      <UserRoute path="/user"/>
      <SellerRoute path="/seller"/>
      <SellerManagerRoute path="/sellermanager"/>
      <ShopRoute path="/shop"/>
      <SecurityRoute path="/security"/>
      <ReSellerRoute path="/reseller"/>
      
      
      <QRCodeRoute path="/qrcode" />
      <PrintQRCode path='/printqr'/>

      <MainCameras path='/testcameras'/>
      
      <LastOrder path='/last/order'/>
      <MainePOS path='/epos'/>
      <NiceReport path='/nicereport'/>
      <MainAccess path="/access"/>

      <PDFTest path='/test'/>
      <NewEventSales path='/newsalesreport'/>


      <NewEvent path='/newevents'/>
      <ClientViewOrder path='/vieworder'/>
      
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);